import React from "react";
import "./brand.css";

import imgGoo from "../../assets/google.png";
import imgSla from "../../assets/slack.png";
import imgAtl from "../../assets/atlassian.png";
import imgDro from "../../assets/dropbox.png";
import imgSho from "../../assets/shopify.png";

const Brand = () => {
  return (
    <div className="gpt3__brand-row">
      <div className="gpt3__brand-logoContainer">
        <img src={imgGoo} alt="imgGoo" />
        <img src={imgSla} alt="imgSla" />
        <img src={imgAtl} alt="imgAtl" />
        <img src={imgDro} alt="imgDro" />
        <img src={imgSho} alt="imgSho" />
      </div>
    </div>
  );
};

export default Brand;
